<template>
 <div class="main">

  <div class="row infos">
    <div class="col-xl-4 col-lg-12">
      <div class="blc-dados">
        <img src="/img/icon-grups.png" alt="icone porto">
        <p>List Users</p>
      </div>
    </div>
  </div>


  <div class="fundo">
    <div class="blc-inf-geral">
      <div class="blc-item">
       
        <div class="row">
          <div class="col-md-6 col-12">
            <h2>List</h2>
          </div>

          <div class="col-md-6 col-12 txt-right">
            <button class="submit-verde"  @click="cleanFiltros()">Clear Filters <img src="/img/icon-filter.png"></button>
            <button class="submit"  @click="$router.push('/usuarios/adicionar')">New user +</button>
          </div>
        </div>
        <form>
          <div class="row">
            <div class="mrg-top-30 col-sl-3 col-lg-3 col-md-6 col-12">
              <base-input
              alternative=""
              label="Name"
              placeholder="search by name"
              input-classes="form-control-alternative"
              v-model.lazy="search.name"
              />
            </div>

            <div class="mrg-top-30 col-sl-3 col-lg-3 col-md-6 col-12">            
             <base-input
             alternative=""
             type="email"
             label="Email"
             placeholder="search by email"
             input-classes="form-control-alternative"
             v-model.lazy="search.email"
             />
           </div>

           <div class="mrg-top-30 col-sl-3 col-lg-3 col-md-6 col-12">
            <base-select
            alternative=""
            label="Profile"
            placeholder="select the profile"
            :options="Service.roles()"
            input-classes="input"
            v-model="search.role_id"
            />
          </div>

          <div class="mrg-top-30 col-sl-3 col-lg-3 col-md-6 col-12">
            <button style="margin-top: 32px;" class="submit w-100" value="Search"   :disabled="loading"
            @click="listar()"> <i class="fa fa-spinner fa-spin" v-if="loading" /> Search </button>
          </div>

        </div>
      </form>

    </div>

     <div class="blc-tabela tabela-listagem scroll" style="overflow: visible;">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Profile</th>
            <th>Created in</th>
            <th>Suspended Until</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in list" :key="list.id">
           <td>
            {{ row.name }}
          </td>
          <td>
            {{ row.email }}
          </td>
          <td>
            {{ row.role.name }}
          </td>
          <td>
            {{ row.created_at |date}}
          </td>
          <td>
            <span v-if="row.suspended_at">{{ formatDate(row.suspended_at) }}</span>
            <span v-else>-</span>
          </td>
          

          <td class="text-right">
             <base-dropdown class="dropdown" position="right" direction="up" :open="row.id === activeDropdownId">
            <a 
            slot="title"
            class="btn btn-sm btn-icon-only "
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            >
            <i class="fas fa-ellipsis-v"></i>
          </a>

          <template>
            <router-link
            class="dropdown-item"
            :to="'/usuarios/editar/' + row.id"
            ><i class="fas fa-edit"></i> edit</router-link
            >
            <a
            class="dropdown-item"
            href="#"
             @click="toggleDropdown(row.id); $root.openExcluirModal(
               row,
               'Would you like to delete the user ' +
               row.name +
               '?',
               Service
               )"
              ><i class="fas fa-trash" style="min-width: 20px"></i>
              delete</a
              >
              <a class="dropdown-item" href="#" v-if="isSuperAdmin && (!row.suspended_at || !isFuture(row.suspended_at))" @click="openSuspend(row)" :class="{ 'disabled': suspendLoading }"><i class="fas fa-user-slash" style="min-width: 20px"></i> Suspend</a>
              <a class="dropdown-item" href="#" v-if="isSuperAdmin && row.suspended_at && isFuture(row.suspended_at)" @click="openUnsuspendModal(row)" :class="{ 'disabled': unsuspendLoading }"><i class="fas fa-user-check" style="min-width: 20px"></i> Remove Suspension</a>
            </template>
          </base-dropdown>
        </td>
      </tr>
      <tr v-if="!list.length && !loading">
        <td colspan="100" style="text-align: center">No users found</td>
      </tr>
      <tr v-if="loading">
        <td colspan="100" style="text-align: center">
          <i
          class="fa fa-spinner fa-spin"
          v-if="loading"
          style="font-size: 20px"
          ></i>
        </td>
      </tr>

    </tbody>
  </table>
</div>
</div>
</div>

<base-pagination
:pagination="pagination"
@change="listar()"
align="center"
></base-pagination>


<excluir-modal
:show="$root.modal.excluir.isOpen"
:mensagem="$root.modal.excluir.mensagem"
:model="$root.modal.excluir.model"
:service="$root.modal.excluir.service"
@close="handleExcluir"
></excluir-modal>

<modal :show.sync="suspendModal.show">
  <template slot="header">
    <h5 class="modal-title">Suspend User</h5>
  </template>
  <div>
    <div class="form-group">
      <label>User</label>
      <input type="text" class="form-control" :value="suspendModal.model.name" disabled>
    </div>
    <div class="form-group">
      <label>Suspended Until</label>
      <input type="datetime-local" class="form-control" v-model="suspendModal.model.suspended_at">
    </div>
  </div>
  <template slot="footer">
    <button class="btn btn-secondary" @click="suspendModal.show=false" :disabled="suspendLoading">Cancel</button>
    <button class="btn btn-primary" @click="submitSuspend()" :disabled="suspendLoading">
      <i class="fa fa-spinner fa-spin" v-if="suspendLoading" style="margin-right: 5px;"></i>
      Suspend User
    </button>
  </template>
</modal>

<modal :show.sync="unsuspendModal.show">
  <template slot="header">
    <h5 class="modal-title">Remove Suspension</h5>
  </template>
  <div>
    <div class="form-group">
      <label>User</label>
      <input type="text" class="form-control" :value="unsuspendModal.model.name" disabled>
    </div>
    <div class="form-group">
      <label>Current Suspension</label>
      <input type="text" class="form-control" :value="formatDate(unsuspendModal.model.suspended_at)" disabled>
    </div>
    <div class="alert alert-warning">
      <i class="fas fa-exclamation-triangle"></i>
      Are you sure you want to remove the suspension for this user? This action cannot be undone.
    </div>
  </div>
  <template slot="footer">
    <button class="btn btn-secondary" @click="unsuspendModal.show=false" :disabled="unsuspendLoading">Cancel</button>
    <button class="btn btn-danger" @click="confirmUnsuspend()" :disabled="unsuspendLoading">
      <i class="fa fa-spinner fa-spin" v-if="unsuspendLoading" style="margin-right: 5px;"></i>
      Remove Suspension
    </button>
  </template>
</modal>
</div>
</template>
<script>
  import Service from "@/services/Usuarios";
  import Modal from "@/components/Modal/Modal";
  export default {
    components: { Modal },
    data() {
      return {
        Service,
        loading:false,
        isSuperAdmin: false,
        suspendLoading: false,
        unsuspendLoading: false,
        activeDropdownId: null,
        suspendModal: {
          show: false,
          model: {
            id: null,
            name: '',
            suspended_at: ''
          }
        },
        unsuspendModal: {
          show: false,
          model: {
            id: null,
            name: '',
            suspended_at: ''
          }
        },
        pagination: {
          page: 1,
          last_page: 1,
          per_page: 20,
          total:1
        },
        search:{
          name:'',
          email:'',
          role_id:null
        },
        defaultSearch:{},
        orderBy: {
          campo: "FORNECEDOR",
          ordem: "asc",
        },
        list: [,
        ],
      };
    },
    created(){
     this.defaultSearch = {...this.search};
     this.checkUserRole();
     this.listar();
   },
   watch: {
      orderBy: {
        deep: true,
        handler() {
          this.pagination.page = 1;
          this.listar();
        },
      },
    },
     methods: {
     toggleDropdown(userId) {
       this.activeDropdownId = this.activeDropdownId === userId ? null : userId;
     },
     checkUserRole(){
       const user = this.$store.getters.user || JSON.parse(localStorage.getItem('user'));
       this.isSuperAdmin = user && user.role_id === 1;
     },
    formatDate(value){
      if(!value) return '-';
      const d = new Date(value);
      const pad = (n) => (n<10? '0'+n : n);
      return `${pad(d.getDate())}/${pad(d.getMonth()+1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    isFuture(value){
      return new Date(value).getTime() > Date.now();
    },
     openSuspend(row){
       this.activeDropdownId = null; // Fechar dropdown ao abrir modal
       this.suspendModal.model = {
         id: row.id,
         name: row.name,
         suspended_at: ''
       };
       this.suspendModal.show = true;
     },
     openUnsuspendModal(row){
       this.activeDropdownId = null; // Fechar dropdown ao abrir modal
       this.unsuspendModal.model = {
         id: row.id,
         name: row.name,
         suspended_at: row.suspended_at
       };
       this.unsuspendModal.show = true;
     },
    submitSuspend(){
      const { id, suspended_at } = this.suspendModal.model;
      if(!suspended_at){
        this.$notify({ type:'danger', message: 'Select a suspension date', horizontalAlign:'center' });
        return;
      }
      
      this.suspendLoading = true;
      Service.suspend({ user_id: id, suspended_at })
        .then(()=>{
          this.$notify({ type:'success', message:'User suspended successfully!', horizontalAlign:'center' });
          this.suspendModal.show = false;
          this.listar();
        })
        .catch(err=>{
          const msg = (err.response && err.response.data && (err.response.data.message || err.response.data.detail)) || 'Error while suspending user';
          this.$notify({ type:'danger', message: msg, horizontalAlign:'center' });
        })
        .finally(() => {
          this.suspendLoading = false;
        });
    },
     confirmUnsuspend(){
       this.unsuspendLoading = true;
       Service.unsuspend(this.unsuspendModal.model.id)
         .then(()=>{
           this.$notify({ type:'success', message:'Suspension removed successfully!', horizontalAlign:'center' });
           this.unsuspendModal.show = false;
           this.listar();
         })
         .catch(()=>{
           this.$notify({ type:'danger', message:'Error while removing suspension', horizontalAlign:'center' });
         })
         .finally(() => {
           this.unsuspendLoading = false;
         });
     },
     handleExcluir(updated){
      this.$root.modal.excluir.isOpen = false
      if(updated)
        this.listar();
    },
    cleanFiltros(){
      this.search = {...this.defaultSearch};
      this.listar();
    },
    listar(){
      this.loading = true;
      this.list = [];
      Service.get({
        with:['role'],
        ...this.pagination,
        ...this.search
      }).then(response => {
        this.list = response.data.data;
        this.pagination.last_page = response.data.last_page;
        this.pagination.total = response.data.total;
        this.loading = false;
      });
    },
  },
};
</script>
<style>
.dropdown-item.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.fa-spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Estilos para o modal de remoção de suspensão */
.alert-warning {
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  color: #856404;
  padding: 12px 16px;
  border-radius: 6px;
  margin-top: 15px;
}

.alert-warning i {
  margin-right: 8px;
  color: #f39c12;
}

/* Estilos para dropdown que abre para cima */
.dropdown-menu {
  position: absolute !important;
  bottom: 100% !important;
  top: auto !important;
  right: 0 !important;
  left: auto !important;
  z-index: 9999;
  min-width: 180px;
  max-width: 220px;
  white-space: nowrap;
  overflow: visible;
  margin-bottom: 5px;
  transform: translateY(0) !important;
}

.dropdown-menu.show {
  display: block !important;
  transform: translateY(0) !important;
}

/* Estilos para itens do dropdown */
.dropdown-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  min-height: 36px;
}

.dropdown-item i {
  margin-right: 8px;
  min-width: 16px;
  text-align: center;
}

/* Garantir que o dropdown não seja cortado */
.blc-tabela {
  overflow: visible !important;
}

.tabela-listagem {
  overflow: visible !important;
}

/* Melhorar responsividade da tabela */
@media (max-width: 768px) {
  .dropdown-menu {
    right: -10px !important;
    left: auto !important;
    min-width: 160px;
    max-width: 180px;
  }
  
  .blc-tabela {
    overflow-x: auto !important;
    overflow-y: visible !important;
  }
}

#conteudo .main .blc-dados img {
    background: #59b528;
  }
</style>
